import { render } from "./notassupervision.vue?vue&type=template&id=4d6fb87e&scoped=true"
import script from "./notassupervision.vue?vue&type=script&lang=js"
export * from "./notassupervision.vue?vue&type=script&lang=js"

import "./notassupervision.vue?vue&type=style&index=0&id=4d6fb87e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6fb87e"]])

export default __exports__